exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vh90{max-height:78VH;overflow-y:scroll}", ""]);

// exports
